import ReactGA from "react-ga4";

const TRACKING_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
let isInitialized = false;
let hasAnalyticsConsent = false;
let lastTrackedPage = "";

/**
 * Initializes GA4 only after consent is granted.
 */
export const initGA = () => {
  if (!TRACKING_ID) {
    console.warn("Tracking ID not found. Analytics disabled.");
    return;
  }

  if (isInitialized) {
    return;
  }

  ReactGA.initialize(TRACKING_ID);
  isInitialized = true;
};

/**
 * Updates consent to granted. Call this when user clicks "Accept".
 */
export const grantConsent = () => {
  hasAnalyticsConsent = true;
  initGA();

  if (!isInitialized) {
    return;
  }

  ReactGA.gtag("consent", "update", {
    analytics_storage: "granted",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
  logPageView();
  console.log("Analytics: Consent Granted");
};

/**
 * Explicitly denies consent. Call this if the user clicks "Decline".
 */
export const denyConsent = () => {
  hasAnalyticsConsent = false;

  if (!isInitialized) {
    return;
  }

  ReactGA.gtag("consent", "update", {
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
  console.log("Analytics: Consent Denied");
};

/**
 * Logs a page view only after analytics consent has been granted.
 */
export const logPageView = () => {
  if (!hasAnalyticsConsent || !isInitialized) {
    return;
  }

  const page = window.location.pathname + window.location.search;
  if (page === lastTrackedPage) {
    return;
  }

  lastTrackedPage = page;
  ReactGA.send({
    hitType: "pageview",
    page,
  });
};

/**
 * Logs custom events (e.g., button clicks).
 */
export const logEvent = (category, action, label) => {
  if (!hasAnalyticsConsent || !isInitialized) {
    return;
  }

  ReactGA.event({
    category: category,
    action: action,
    label: label,
  });
};

export const userHasAnalyticsConsent = () => hasAnalyticsConsent;
